import { useState } from "react";
import { faqs } from "@/mocks/manga";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="mx-auto w-full max-w-4xl px-4 py-14 md:px-6 md:py-20">
      <div className="text-center">
        <p className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-sm font-medium text-accent-800">
          <i className="ri-question-line"></i>
          常见问题
        </p>
        <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">追更之前，先看这里</h2>
        <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-600 md:text-base">
          关于追更进度条、榜单刷新与连载更新，你最想知道的答案都在下面。
        </p>
      </div>

      <div className="mt-8 space-y-3">
        {faqs.map((item, i) => {
          const open = openIndex === i;
          return (
            <div
              key={item.q}
              className={`overflow-hidden rounded-lg bg-background-100 ring-1 transition-colors ${
                open ? "ring-primary-300" : "ring-background-200/70"
              }`}
            >
              <button
                type="button"
                onClick={() => setOpenIndex(open ? -1 : i)}
                className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                aria-expanded={open}
              >
                <span className="font-medium text-foreground-950">{item.q}</span>
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                    open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                  }`}
                >
                  <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-lg`}></i>
                </span>
              </button>
              {open && (
                <div className="px-5 pb-5 text-sm leading-relaxed text-foreground-700">{item.a}</div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}